import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import ReactPlayer from 'react-player';
import HtmlParser from 'html-react-parser';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import { DemoFormShortPDFNoBackground } from '../../../components/DemoFormShortPDFNoBackground.jsx';
import MultimedialPanel from '../../../components/MultimedialPanel';


const HeadcountPlanningGuideCFO = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;


    return (
        <Layout bodyClass="headcount-planning-guide-cfo" ontouchstart>
            <SEO title=" How to Confidently Approach 2022 Headcount Planning | Guide | ChartHop" />
            <Helmet>
                <meta
                    name="description"
                    content="Effective headcount planning can increase growth, innovation, and employee retention. Download the guide to discover what it takes to achieve these results for your organization."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="How to Confidently Approach 2022 Headcount Planning | Guide | ChartHop" />
                <meta property="og:description" content="Effective headcount planning can increase growth, innovation, and employee retention. Download the guide to discover what it takes to achieve these results for your organization." />
                <meta property="og:image" content={`https://www.charthop.com/resources/guides-ebooks/headcount-planning-cfo/cfo-headcount-planning-preview.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="How to Confidently Approach 2022 Headcount Planning | Guide | ChartHop" />
                <meta name="twitter:description" content="Effective headcount planning can increase growth, innovation, and employee retention. Download the guide to discover what it takes to achieve these results for your organization." />
                <meta name="twitter:image" content={`https://www.charthop.com/resources/guides-ebooks/headcount-planning-cfo/cfo-headcount-planning-preview.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>

            {/* HEADER h4*/}
            <section className="hero-dei-reporting">
                <div className="row bottom-formPDF sectionSpacing contentBlock section-big">
                    <div className="headerContent col-md-6 col-sm-12 text-left padding-left-headerContent">
                        <h1 className="h1-correct">
                            How to Confidently Approach Your 2022 Headcount Planning
                        </h1>
                        <span class="cfo-tag"> CFO Edition </span>
                    </div>
                </div>
                <div className="top-formPDF sectionSpacing contentBlock justify-content-md-start justify-content-center section-big">
                    <DemoFormShortPDFNoBackground pdfUrl={'/resources/guides-ebooks/headcount-planning-cfo/CFO_Headcount_planning.pdf'} source={"resources-CFO-headcount-planning-2022-PDF-contentdownload-header"} />
                </div>
            </section>

            <section className="sectionSpacing flex-centeredColumn dei-section">
                <div className="contentBlock">
                    <h2 className="text-center mt-0  sectionSpacing-Margin planForwardTitle"> 
                        Headcount planning has never been as important as it is heading into 2022, making it absolutely critical for CFOs to get it right. This guide will explore exactly what that takes, including:
                    </h2>
                    <div className="flex-centeredColumn contentBlock">
                        <div className="pgc1 pgc1-v2">
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Why headcount planning matters for CFOs</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>The realities of headcount planning in 2022</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Why headcount planning has traditionally been so complex</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Easing complexity with best practices for strategic headcount planning</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>What's required to give your headcount planning the strategic attention it deserves</p>
                                </div>
                            </div>
                        </div>
                        <p className="text-center my-2 planForwardSubTitle">
                            Effective headcount planning can drive faster growth, greater innovation, and promote a better employee experience that leads to increased retention. Download the guide to discover how you can achieve these results for your organization.
                        </p>
                    </div>
                </div>
            </section>

            {/* TRUSTED */}
            <section className="customer testimonial-container pt-8 pb-5 backgroundGradientContainer">
                <JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>

            




  
            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo request-demo-white pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"resources-CFO-headcount-planning-2022-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“ChartHop gives me a time series view of our workforce and easily allows leaders to see how company resourcing needs change over time. This allows me to forecast future headcount and spend changes.”</p><div class="authorTag"><img src="/customers/even/weifang-zhu_even-th.jpg" class="testimonialAuthor" alt="Weifang Zhu" /><div><p class="contactAuthor"><strong>Weifang Zhu</strong> <br>SVP Growth & Operations at Even Financial</p></div></div>')}/>
			</section>

        </Layout>
    );
};


export default HeadcountPlanningGuideCFO;

export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;